import Vue from 'vue';

export const GLOBAL_ADDRESS_CHANGE = 'GLOBAL_ADDRESS_CHANGE'; // 地址发生了改变
export const ORDER_DETAIL_REFRESH = 'ORDER_DETAIL_REFRESH'; // 地址发生了改变

export const eventBus = new Vue();
